<template>
  <div>
    <div v-if="loading !== true">
      <apexchart width="100%" :height="calculatedHeight" type="bar"
                 :options="userChartOptions"
                 ref="userChart"
                 :series="userSeries"
      ></apexchart>
    </div>
    <div v-else>
      <b-skeleton-img style="height: 200px"></b-skeleton-img>
    </div>
  </div>
</template>


<script>
export default {
  name: 'UserSalesBarChart',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    chartData: {
      type: Object,
      default: () => ({})
    },
    currencyFormat: {
      type: Boolean,
      default: true
    },
    isDarkSkin: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({}),
  watch: {
    chartData() {
      if (this.$refs['userChart'] != null) {
        this.$refs['userChart'].refresh();
      }
    }
  },
  computed: {
    calculatedHeight() {
      // Calculate height based on the number of items in the series
      const dataCount = this.userSeries.length > 0 ? this.userSeries[0].data.length : 0;
      return Math.max(400, dataCount * 40); // Adjust the multiplier (40) as per your design
    },
    userSeries() {
      let data = Object.values(this.chartData)
          .map(value => parseFloat(value)
              .toFixed(2));
      return [{
        name: 'User Chart',
        data,
      }];
    },

    labelColor() {
      return this.isDarkSkin ? '#b4b7bd' : '#2b7194';
    },
    dataLabelColor() {
      return this.isDarkSkin ? '#d0d2d6' : '#000000';
    },
    titleColor() {
      return this.isDarkSkin ? '#d0d2d6' : '#1c9bda';
    },
    userChartOptions() {
      let $this = this;
      let categories = Object.keys(this.chartData);
      return {
        chart: {
          type: 'bar',
          background: 'transparent',
        },
        grid: {
          show: false,
        },
        theme: {
          mode: this.isDarkSkin ? 'dark' : 'light',
          palette: 'palette1',
          monochrome: {
            enabled: false,
            color: '#255aee',
            shadeTo: this.isDarkSkin ? 'dark' : 'light',
            shadeIntensity: 0.65
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 0,
            borderRadiusApplication: 'around',
            borderRadiusWhenStacked: 'last',
            columnWidth: '10%',
            barHeight: '75%',
            distributed: false,
            rangeBarOverlap: true,
            rangeBarGroupRows: false,
            hideZeroBarsWhenGrouped: false,
            isDumbbell: false,
            dumbbellColors: undefined,
            isFunnel: false,
            isFunnel3d: true,
            horizontal: true,
            dataLabels: {
              position: 'right'
            },
          }
        },

        dataLabels: {
          style: { colors: [this.dataLabelColor] },
          position: 'top',
          enabled: true,
          formatter: function (val, opt) {
            if (!$this.currencyFormat) {
              return new Intl.NumberFormat('de-AT', {
                style: 'currency',
                currency: 'EUR',
              }).format(val);
            } else {
              return '#' + val;
            }
          },
          dropShadow: {
            enabled: true,
          },
        },
        title: {
          text: 'User Chart',
          align: 'middle',
          style: {
            fontSize:  '14px',
            fontWeight:  'bold',
            fontFamily:  undefined,
            color:  this.titleColor
          },
        },

        xaxis: {
          categories,
          labels: {
            style: {
              colors: this.labelColor
            }
          }
        },

        yaxis: {
          labels: {
            style: {
              colors: this.labelColor,
              fontSize:  '14px',
              fontWeight:  'bold',
              fontFamily:  undefined,

            }
          }
        },
        legend: {
          show:false,
          position: 'right',
          horizontalAlign: 'center',
        },
      };
    }
  }
};
</script>

<style scoped>

</style>
